
import API from '../api/axios';
import jbAPI from "./jobboard";

export const validateEmail = async (email) => {
  try {
    const response = await API.post("/validateEmail", {
      email,
    });

    return response.data; 
    // { exists: true/false, emailId: "test@gmail.com" }
  } catch (error) {
    console.error("Failed to validate email:", error);
    return { exists: false };
  }
};

export const validateMobile = async (mobileNumber) => {
  try {
    const response = await API.post("/validateMobile", {
      mobileNumber,
    });

    return response.data; 
    // { exists: true/false, emailId: "test@gmail.com" }
  } catch (error) {
    console.error("Failed to validate mobile number:", error);
    return { exists: false };
  }
};

export const validateCompany = async (companyName) => {
  try {
    const response = await jbAPI.post("/validatCompanyName", {
      companyName,
    });

    return response.data; 
    // { exists: true/false, emailId: "test@gmail.com" }
  } catch (error) {
    console.error("Failed to validate company name:", error);
    return { exists: false };
  }
};